import { ProviderName } from 'v2/constants';
import { SelectOption } from 'v2/types';

export function getBetOptions(bets: number[], provider: ProviderName): SelectOption<number>[] {
  if (provider === ProviderName.ONESPIN4WIN) {
    return bets.map((b, index) => ({ id: b.toString(), value: index + 1, label: b }));
  }

  return bets.map((b) => ({ id: b.toString(), value: b, label: b }));
}
